import httpRequest from "./http";
import QS from "qs";
import {GOk,GEr,overlay} from "./GlobalHandle";
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
async function exeRequest(url, params,{method='get',type='application/x-www-form-urlencoded',passError=false,showError=true,showOverlay=true
    // ,beforeExe=async ()=>{}
}){

    // if(beforeExe=!null){
    //     await beforeExe();
    // }
    overlay(showOverlay,true);
    httpRequest.defaults.headers[method]["Content-Type"] = type == "" ? "application/json" : type;
    let data = method=="get"?{params}:((method=="post" && type != "")?QS.stringify(params):params);
    return new Promise((resolve, reject) => {
        httpRequest[method]
            // eslint-disable-next-line no-unexpected-multiline
            (url, data)
            .then((res) => {
                overlay(showOverlay,false);
                GOk(resolve,res);
            })
            .catch((err) => {
                overlay(showOverlay,false);
                GEr(reject,err,passError,showError);
            });
    });
}

export function get(url, params, exts={}) {
    return exeRequest(url, params,exts);
}

export function post(url, params, exts={}) {
    exts['method'] = 'post';
    return exeRequest(url, params,exts);
}
